// import { TOUCH_BUFFER_MS } from  '@angular/cdk/a11y/input-modality/input-modality-detector';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import * as _ from 'lodash';
import { forkJoin } from 'rxjs';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { SendFeedbackComponent } from 'src/app/moov-common/components/send-feedback/send-feedback/send-feedback.component';
import { IssueData, MoovData, MoovInstanceData, MoovViewData } from 'src/app/moov-common/services/challenge/challenges-data';
import { AbstractChallengesService } from 'src/app/moov-common/services/challenge/challenges.abstract.service';
import { PersonalUserData } from 'src/app/moov-common/services/personal-user-data/personal-user-data';

@Component({
  selector: 'app-select-moov',
  templateUrl: './select-moov.component.html',
  styleUrls: ['./select-moov.component.scss']
})
export class SelectMoovComponent   extends BaseComponent implements OnInit {
moovsImagesRootFolder = 'assets/moovs/';

@Input() issueId: string;
@Input() motivationId : string = "";
@Input() counterpartDetails: PersonalUserData;
@Input() isSelectMoovForSelf : boolean = false;
@Output() moovSelectedEvent = new EventEmitter<string>();
selectedMoov: MoovViewData;
topMoovsDetailsList: MoovData[];
extraMoovsDetailsList: MoovData[];
allMoovsList: MoovData[];
pastMoovs:MoovInstanceData[];
activeMoovs:MoovInstanceData[];
issueDetails : IssueData;
issueName : string = "";
isSelectedMoov = false;
pastMoovsIndicatorMap: Map<string, boolean>;
activeMoovsIndicatorMap: Map<string, boolean>;
presentFullMoovsList = false;
bestMoovId = "";
  breakpoint: number;
  PC_VIEW_COLS_NUM = 4;
  MOBILE_VIEW_COLS_NUM = 1;
@ViewChild("moovSideNav") sideNavRef: MatSidenav;

  constructor(private readonly challengesService: AbstractChallengesService, public dialog: MatDialog ) {
    super();
    if (this.isMobileView){
      this.breakpoint = this.MOBILE_VIEW_COLS_NUM;
    }
    else{
      this.breakpoint = this.PC_VIEW_COLS_NUM;
    }
    // console.log(`this.breakpoint `+this.breakpoint);
    this.pastMoovsIndicatorMap = new Map<string, boolean>();
    this.activeMoovsIndicatorMap = new Map<string, boolean>();
   }

  ngOnInit(): void {
    super.ngOnInit();
    // console.log(`SM onInit`);
    if (this.issueId != undefined){
      this.getIssueDetails();
    }

    if (this.issueId != undefined && this.counterpartDetails != undefined){
      this.getMoovsAndPast();
    }
    else if (this.isSelectMoovForSelf && this.issueId !+ undefined){
      this.getMoovsAndPast();
    }
  }

  ngOnChanges(changes: SimpleChanges) : void {
    this.ifChanged(changes.counterpartDetails, ()=>this.getMoovsAndPast());
    // if (changes.counterpartDetails != undefined && this.issueId != undefined && this.counterpartDetails != undefined){
    //   this.getMoovsAndPast();
    // }
  }

  getMoovsAndPast(): void {
    if (!this.user){
      return;
    }

    console.log(`SM getMoovsAndPast`);

    if (!this.isSelectMoovForSelf){
      if (!this.counterpartDetails){
        return;
      }

      forkJoin({
        moovs : this.challengesService.getMoovsPerIssueAndCounterpart(this.counterpartDetails.id, this.issueId, this.motivationId),
        pastMoovs : this.challengesService.getPastMoovsForUserCounterpart(this.counterpartDetails.id),
        activeMoovs: this.challengesService.getActiveMoovsForUserCounterpart(this.counterpartDetails.id)
      }).subscribe(({moovs, pastMoovs, activeMoovs})=>{
        // order the moovs list by their score
        this.allMoovsList = _.orderBy(moovs, ['score'], ['desc']); 
  
        if (this.allMoovsList.length > 0){
          // save id for the best moov
          this.bestMoovId = this.allMoovsList[0].id;
        }
        this.pastMoovs = pastMoovs;
        this.activeMoovs = activeMoovs;
        this.setMoovsInList();
      });  
    }
    else{
      console.log(`SM getMoovsForSelf`);
      forkJoin({
        moovs : this.challengesService.getmoovsForSelf(this.issueId, this.motivationId),
        pastMoovs : this.challengesService.getPastMoovsForUserCounterpart(this.user.id),
        activeMoovs: this.challengesService.getActiveMoovsForUserCounterpart(this.user.id)
      }).subscribe(({moovs, pastMoovs, activeMoovs})=>{      
      // this.challengesService.getmoovsForSelf(this.issueId, this.motivationId).subscribe(moovs => {
        console.log(`SM moovs returned ${JSON.stringify(moovs)}`);
        this.allMoovsList = _.orderBy(moovs, ['score'], ['desc']); 
  
        if (this.allMoovsList.length > 1 && this.allMoovsList[0].score != this.allMoovsList[1].score){
          // there is a distinct score leader
          this.bestMoovId = this.allMoovsList[0].id;
        }

        // past & active moovs for self
        this.pastMoovs = pastMoovs;
        this.activeMoovs = activeMoovs;
        this.setMoovsInList();
      })
    }
  }

  getIssueDetails (): void{
    this.challengesService.getIssue(this.issueId).subscribe(issue => {
        console.log(`getIssueDetails called ${JSON.stringify(issue)}`);
        this.issueDetails = issue;
        this.issueName = this.issueDetails.name;

        console.log(`getIssueDetails called name is ${this.issueName}`);
    });
  }

  setMoovsInList(): void{
    if (this.allMoovsList.length > 4){
      // get the top 4 moovs in list
      this.topMoovsDetailsList = this.allMoovsList.slice(0, 4);
      this.extraMoovsDetailsList = this.allMoovsList.slice(4, this.allMoovsList.length+1);
    }
    else{
      // get all moovs in the list
      this.topMoovsDetailsList = this.allMoovsList;
      this.extraMoovsDetailsList = []; 
    }

      // Create a boolean dictionary with all the moovs, pointing for past moovs.
      for (var currMoov of this.allMoovsList){
        let doesMoovHavePast = false;
        let isMoovActive = false;

        let pastMoov = this.pastMoovs.find(x => x.moovId == currMoov.id); 
        let activeMoov = this.activeMoovs.find(x=> x.moovId == currMoov.id);

        if (pastMoov != undefined){
          doesMoovHavePast = true;
        }

        if (activeMoov != undefined){
          isMoovActive = true;
        }

        this.pastMoovsIndicatorMap.set(currMoov.id, doesMoovHavePast);
        this.activeMoovsIndicatorMap.set(currMoov.id, isMoovActive);
      }
  }

  doesHavePast(moovId: string): boolean{
    const foundPastMoov = this.pastMoovsIndicatorMap.get(moovId);

    if (foundPastMoov != undefined){
      return foundPastMoov;
    }
    else{
      // not found in map
      return false;
    }
  }

  isMoovActive(moovId: string): boolean{
    const foundActiveMoov = this.activeMoovsIndicatorMap.get(moovId);

    if (foundActiveMoov != undefined){
      return foundActiveMoov;
    }
    else{
      // not found in map
      return false;
    }
  } 

  seeAllMoovs() : void{
    if (this.isSelectMoovForSelf){
      // this.analytics.showMoreMoovsSelected(this., this.issueId);
    }
    else{
      if (this.counterpartDetails){
        this.analytics.showMoreMoovsSelected(this.counterpartDetails.id, this.issueId);
      }
    }


    this.presentFullMoovsList = true;
  }

  openMoov (moovId: string, isTopMoov: boolean): void{
  
      let selectedMoovDetails : MoovData | undefined;

      if (isTopMoov){
       selectedMoovDetails = this.topMoovsDetailsList.find (am => am.id == moovId);
      }
      else{
        selectedMoovDetails = this.extraMoovsDetailsList.find (am => am.id == moovId);
      }
  
      if (selectedMoovDetails == undefined){
        return;
      }
   
      let counterpartId = "";
      if (this.counterpartDetails){
        counterpartId = this.counterpartDetails.id;
      }
      this.selectedMoov = {moovDetails:selectedMoovDetails, isPastMoov:false, isActiveMoov:false, counterpartId:counterpartId};
        
    this.isSelectedMoov = true;
    
    if (!this.isSelectMoovForSelf && this.counterpartDetails){
      this.analytics.moovViewedEvent(this.counterpartDetails.id, this.issueId, moovId);
    }
    else{
      // no counterpartId
      this.analytics.moovViewedEvent("", this.issueId, moovId);
    }
    
      this.sideNavRef.open();
  }

  getPastMoovsForMoov(moovId: string): MoovInstanceData[]{
    if (this.pastMoovs.length == 0){
      return [];
    }

    const relevantPastMoovs = _.filter(this.pastMoovs, {'moovId': moovId});

    return relevantPastMoovs;
  }

  moovActivated(moovId: string): void{
    this.sideNavRef.close();
    this.moovSelectedEvent.emit();
  }

  closeMoovView() {
    this.sideNavRef.close();
  }

  sendFeedback(): void{
    this.dialog.open(SendFeedbackComponent, {
      height: 'fit-content',
      width: (this.isMobileView? '90%':'40%'),
      data: {dialogRef: this.dialog}
    });
  }
}
